"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFunction: function (appUUID, serId, keyName, keyTime, version) { return function (dispatch, getState) {
        var appState = getState();
        var body = {
            'app_uuid': appUUID,
            'service_id': serId,
            'key_name': keyName,
            'extra_data': "",
            'expires_in': keyTime
        };
        if (appState && appState.registerTokenModel) {
            console.log("call api create token -" + appUUID + "-" + serId + "-" + keyName);
            fetch("/v1/key", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                dispatch({ type: 'RECEIVE_REGISTERTOKEN', model: data, version: version });
            })
                .then(function (error) {
            });
            dispatch({ type: 'REQUEST_REGISTERTOKEN' });
        }
    }; }
};
var unloadedState = { isLoading: false, response: undefined, version: 0 };
var reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_REGISTERTOKEN':
            return {
                isLoading: false,
                version: 0
            };
        case 'RECEIVE_REGISTERTOKEN':
            return {
                isLoading: true,
                response: action.model,
                version: action.version + 1
            };
        default: return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=RegisterToken.js.map